const PharmacyInfo = ({ pharmacyInfo, setPharmacyInfo }) => {

    const updateField = (field, value) => {
    setPharmacyInfo((prev) =>
      prev.map((item, index) =>
        index === 0 ? { ...item, [field]: value } : item
      )
    );
  };
  return (
    <div className="row">
      <div className="col-12">
        <label htmlFor=" " className="form-label">
          الاسم الشائع  
        </label>
        <input
          type="text"
          className="form-control"
 onChange={(e) =>
            updateField("generic_name", e.target.value)
          }
                    value={pharmacyInfo[0]?.generic_name}

        />
      </div>
      <div className="col-12">
        <label htmlFor="" className="form-label">
          الاستخدام الشائع 
        </label>
        <textarea
          type="text"
          className="form-control"
          value={pharmacyInfo[0]?.common_use}
                onChange={(e) =>
            updateField("common_use", e.target.value)
          }
        ></textarea>
      </div>

      <label htmlFor="" className="form-label">
        مطلوب وصفة طبية
      </label>

      <label class="switch">
        <input
          type="checkbox"
              onChange={(e) =>
            updateField(
              "prescription_required",
              e.target.checked ? 1 : 0
            )
          }
       checked={pharmacyInfo[0]?.prescription_required === 1}
        />
        <span className="slider round"></span>
      </label>
    </div>
  );
};

export default PharmacyInfo;
